import React, { useState } from 'react';
import './NewsletterSection.css';
import { db } from './firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';

const NewsletterSection = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    if (!email) return;
    try {
      await addDoc(collection(db, 'newsletter-subscribers'), {
        email,
        subscribedAt: serverTimestamp(),
      });
      setSubmitted(true);
      setEmail('');
    } catch {
      setError('There was an error. Please try again.');
    }
  };

  return (
  <section className="newsletter-section">
    <div className="newsletter-bg" />
    <div className="newsletter-overlay">
      <h2 className="newsletter-title">Stay Updated</h2>
      <p className="newsletter-subtitle">Subscribe to our newsletter for the latest product innovations and exclusive offers</p>
        {submitted ? (
          <div style={{ color: '#359F95', fontWeight: 600, marginTop: 16 }}>Thank you for subscribing!</div>
        ) : (
          <form className="newsletter-form" onSubmit={handleSubmit}>
        <input
          type="email"
          className="newsletter-input"
          placeholder="Enter your email address"
          required
              value={email}
              onChange={e => setEmail(e.target.value)}
        />
        <button className="newsletter-btn" type="submit">Subscribe</button>
      </form>
        )}
        {error && <div style={{ color: 'red', marginTop: 8 }}>{error}</div>}
    </div>
  </section>
);
};

export default NewsletterSection; 